import { effectiveSourceBpm } from './clipTiming';

export const CLIP_FADE_SECONDS = 0.005;

/** Return the portion of a native-rate clip audible from a session-time seek. */
export function clipPlaybackWindow(clip, bpm, fromSec = 0, untilSec = Infinity) {
  const sourceBpm = effectiveSourceBpm(clip, bpm);
  const nativeBarSec = 240 / sourceBpm;
  const start = Number(clip.start_bar || 0) * (240 / Number(bpm));
  const offset = Math.max(0, Number(clip.offset || 0));
  const duration = Math.max(0, Number(clip.bars || 0)) * nativeBarSec;
  const end = start + duration;
  const audibleEnd = Math.min(end, untilSec);
  // Nothing audible: the clip ends before `fromSec`, or (looping) starts at or after `untilSec`.
  // The second case used to yield a negative duration, which made source.start() throw and left
  // loop playback half-started (audio on, playhead frozen).
  if (duration <= 0 || audibleEnd <= fromSec || start >= untilSec) return null;
  const enteredMidway = fromSec > start;
  const availableNative = Number(clip.naturalLoopBars ?? (Number(clip.bars || 0) + offset));
  return {
    elapsed: Math.max(0, fromSec - start),
    when: Math.max(0, start - fromSec),
    bufferOffset: offset * nativeBarSec + Math.max(0, fromSec - start),
    duration: audibleEnd - Math.max(start, fromSec),
    fadeIn: offset > 0 || enteredMidway,
    fadeOut: offset + Number(clip.bars || 0) < availableNative || audibleEnd < end,
  };
}
